import React from 'react';
import RenunciaReceitasForm from './RenunciaReceitasForm.react';
import * as actions from './Actions';
import { connect } from 'react-redux';
import NotasExplicativas from '../notaexplicativa/Form.react';
import PropTypes from 'prop-types';
import Component from 'react-pure-render/component';
import { addPagination } from 'portaltransparencia-common/libs/AddFilter';
import RenunciaReceitasList from './RenunciaReceitasList.react';
import PageHeader from '../components/PageHeader.react.js';
import configuration from 'portaltransparencia-common/config/Config';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';

export class RenunciaReceitasPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      tipoMovimentacaoTributo: '',
      currentTabSearched: ''
    };
  }

  static propTypes = {
    findRenunciaReceitas: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired
  };

  createParams = (filter, page) => {
    const { tipoMovimentacaoTributo } = this.state;
    const params = new URLSearchParams({
      tipoMovimentacaoTributo: tipoMovimentacaoTributo,
      dataInicial: filter.dataInicial,
      dataFinal: filter.dataFinal
    });

    filter.cpfCnpj && params.append('cpfCnpj', filter.cpfCnpj);
    filter.contribuinte && params.append('contribuinte', filter.contribuinte);
    return addPagination(page, params.toString());
  };

  findRenunciaReceitas = async params => {
    const { findRenunciaReceitas } = this.props;

    await findRenunciaReceitas(params);
  };

  search = async (filter, page) => {
    const { tipoMovimentacaoTributo } = this.state;

    this.findRenunciaReceitas(this.createParams(filter, page)).finally(() =>
      this.setState({
        filter: filter,
        currentTabSearched: tipoMovimentacaoTributo
      })
    );
  };

  onTabClick = tab => {
    this.setState({ tipoMovimentacaoTributo: tab.name });
  };

  onExport = (exportType, openTab, windowParams, page) => {
    const { apiURL } = configuration;
    const { entidade } = StorageService.getItem('userInfo');
    const { filter } = this.state;

    const params = `${this.createParams(filter, page)}&entidade=${
      entidade.id
    }&exportType=${exportType}`;

    window.open(
      `${apiURL}/api/movimentacao-tributo/report?${params}`,
      openTab,
      windowParams
    );
  };

  render() {
    const { location, page } = this.props;
    const { tipoMovimentacaoTributo, filter, currentTabSearched } = this.state;
    const { search, onTabClick, onExport } = this;

    return (
      <>
        <PageHeader location={location} />
        <NotasExplicativas pathname={location?.pathname} />
        <RenunciaReceitasForm
          search={search}
          tipoMovimentacaoTributo={tipoMovimentacaoTributo}
        />
        <RenunciaReceitasList
          page={page}
          search={search}
          filter={filter}
          onTabClick={onTabClick}
          currentTabSearched={currentTabSearched}
          onExport={onExport}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  page: state.renunciaReceitas.get('page')
});

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(RenunciaReceitasPage);
